import { biaInterfaceTypeOptions, biaIpTypeOptions, diaAccessTechOptions } from "@/common/const";
import { includedOptions } from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const diaIptFormResStrategy: ResponseFormElementsType[] = [
  {
    attribute: "bandWidth",
    type: "text",
    required: true,
    pattern: /^(0(\.128)?|0\.[2-9]\d*|[1-9]\d{0,3}(\.\d+)?|10000)$/,
    patternMessage: "Bandwidth must be a number between 0.128 and 10000",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "select",
    attribute: "interface",
    required: true,

    options: biaInterfaceTypeOptions,
  },
  {
    attribute: "AccessTechnology",
    type: "select",
    options: diaAccessTechOptions,

    required: false,
    selectClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "lastMileProvider",
    type: "text",

    required: true,
    pattern: /^(?!\s*$).+/,
    patternMessage: "Last Mile Provider must not be empty",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "contractTerm",
    type: "select",
    options: [...contractTermsOptions],

    required: true,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "IP",
    type: "select",
    options: biaIpTypeOptions,

    required: false,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "SlaUptime",
    type: "text",

    required: true,
    pattern: /^\d+(\.\d+)?$/,
    patternMessage: "SLA Uptime must be a number greater than or equal to 0",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "localTax",
    type: "text",

    required: true,
    pattern: /^(100(\.0+)?|[0-9]?\d(\.\d+)?|0)$/,
    patternMessage: "Local Tax must be a number between 0 and 100",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "SlaMTTR",
    type: "text",

    required: true,
    pattern: /^\d+(\.\d+)?$/,
    patternMessage: "SLA MTTR must be a number greater than or equal to 0",
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    attribute: "isLocalTax",
    type: "select",

    required: false,
    options: includedOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,

    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },
];
export default diaIptFormResStrategy;
